import styles from '../css/topBar.module.css'
import { BsHouseDoor } from "react-icons/bs";
import { GoSearch } from "react-icons/go";
import { MdAdd } from "react-icons/md";
import { PiCoffeeDuotone } from "react-icons/pi";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { Link, NavLink } from 'react-router-dom';

function TopBar() {
  return (
    <div className={styles['top-bar']}>

      <Link to="/" className={styles['top-bar-link']}>
        <img src="/logo/logoApp.png" alt="logo" className='logo' />  
        GórskaPodwózka
      </Link>
      
      <NavLink
        to="/pogoda"
        className={({ isActive }) =>
          isActive ? `${styles['top-bar-link']} ${styles.active}` : styles['top-bar-link']
        }
        end
      >
        <span>POGODA</span>
      </NavLink>

      <NavLink
        to="/info/postaw-kawe"
        className={({ isActive }) =>
          isActive ? `${styles['top-bar-link']} ${styles.active}` : styles['top-bar-link']
        }
        end
      >
        <span>WESPRZYJ</span>
      </NavLink>

      <NavLink
        to="/info"
        className={({ isActive }) =>
          // aktywny tylko dokładnie przy "/info"
          isActive && window.location.pathname === "/info"
            ? `${styles['top-bar-link']} ${styles.active}`
            : styles['top-bar-link']
        }
      >
        <span>INFORMACJE</span>
      </NavLink>

    </div>
  )
}

export default TopBar;
